import React from 'react';
import { createDashboardPageClassName } from './dashboardPageStyles';

type Props = {
  titleNode: React.ReactNode;
  subtitleNode: React.ReactNode;
  actionNode: React.ReactNode;
};

export const DashboardPageHero: React.FC<Props> = ({
  titleNode,
  subtitleNode,
  actionNode,
}) => {
  return (
    <div className={createDashboardPageClassName('hero')}>
      <div className={createDashboardPageClassName('content')}>
        <div className={createDashboardPageClassName('title-group')}>
          {titleNode}
          {subtitleNode}
        </div>
        <div className={createDashboardPageClassName('actions-group')}>
          {actionNode}
        </div>
      </div>
    </div>
  );
};
